import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Globe from '@apps-common/react-globe';
import MapTool from '@apps-common/ui-maps/MapTool';
import PropTypes from 'prop-types';
import React from 'react';
import RemoveIcon from '@mui/icons-material/Remove';
import {connect} from 'react-redux';
import {useTheme} from '@mui/material/styles';
import {useTranslation} from 'react-i18next';

import {changeMapView} from '@explorer/actions/map';
import {trackEvent} from '@explorer/analytics';

const ZoomControls = props => {
  const theme = useTheme();
  const {t} = useTranslation();
  const onZoom = newZoom => {
    if (newZoom < props.minZoom || newZoom > props.maxZoom) {
      return;
    }
    props.changeMapView({zoom: newZoom});
  };

  const onZoomIn = () => {
    trackEvent('Zoom tool clicked', {
      name: 'Zoom in',
    });
    onZoom(Math.floor(props.zoom + 1));
  };

  const onZoomOut = () => {
    trackEvent('Zoom tool clicked', {
      name: 'Zoom out',
    });
    onZoom(Math.ceil(props.zoom - 1));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        maxWidth: 'inherit',
      }}
    >
      <Box sx={{display: 'flex', flexDirection: 'column'}}>
        <MapTool
          icon={<AddIcon />}
          disabled={props.zoom >= props.maxZoom}
          tooltipTitle={t('mapTools.zoomIn')}
          onClick={onZoomIn}
          sx={{
            borderRadius: '4px 4px 0 0',
            boxShadow: 'none',
          }}
          data-qe="zoom-in"
        />
        <MapTool
          icon={<RemoveIcon />}
          disabled={props.zoom <= props.minZoom}
          tooltipTitle={t('mapTools.zoomOut')}
          onClick={onZoomOut}
          sx={{
            borderRadius: 0,
            boxShadow: 'none',
          }}
          data-qe="zoom-out"
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 40,
          height: 60,
          bgcolor: 'background.paper',
        }}
        data-qe="globe"
      >
        <Globe
          center={props.center}
          markerColor="#00A0B4"
          landColor={theme.palette.grey[500]}
          waterColor="#fff"
        />
      </Box>
      {props.additionalControls}
    </Box>
  );
};

ZoomControls.propTypes = {
  changeMapView: PropTypes.func,
  maxZoom: PropTypes.number,
  minZoom: PropTypes.number,
  zoom: PropTypes.number,
  center: PropTypes.array.isRequired,
  additionalControls: PropTypes.node,
};

const mapStateToProps = state => ({
  zoom: state.map.zoom,
  center: state.map.center,
});

const mapDispatchProps = {
  changeMapView,
};

export default connect(mapStateToProps, mapDispatchProps)(ZoomControls);
